"use client";

import type { ReactNode } from "react";
import { RahuKaal } from "@/components/rahu-kaal";
import type { MuhuratResponse } from "@/lib/api/muhurat";

export default function RahuKaalClient({
  language = "en",
  headingLevel = "h1",
  defaultCity = "New Delhi",
  initialDate,
  initialResult,
  resultOffer,
  crossLinks,
}: {
  language?: "en" | "hi";
  defaultCity?: string;
  initialDate?: string;
  headingLevel?: "h1" | "h2";
  initialResult?: MuhuratResponse | null;
  resultOffer: ReactNode;
  crossLinks: ReactNode;
}) {
  return (
    <div className="intent-interface-timing-first min-h-[calc(100vh-130px)]">
      <RahuKaal
        language={language}
        defaultCity={defaultCity}
        initialDate={initialDate}
        headingLevel={headingLevel}
        initialResult={initialResult}
        resultOffer={resultOffer}
        crossLinks={crossLinks}
      />
    </div>
  );
}
